import React from 'react';
import "../../../components/sandbox/index.css"
import {Arguments} from "../common/Arguments";


const baseUrl = Arguments.reactUrl.replace("/#", "") + "/att/documents/science/"
const ChangeRelationship = () => {
    return (
        <>
            <div>
                <div className="panel panel-default mt-20">
                    <p style={{fontWeight: 'bold', marginLeft: 20, fontSize: 20}}>民办社会科学研究机构变更</p>
                </div>
                <div className="panel panel-default mt-20">
                    <div className="panel-header">（一）变更名称</div>
                    <div className="panel-body">
                        <p>1．召开理事会，讨论通过变更名称事宜。</p>
                        <p>2．向市社科联提交如下材料：</p>
                        <p> （1）变更申请。《关于天津市××××变更名称的请示》
                            <a href={`${baseUrl}关于天津市××××变更名称的请示.docx`}
                               style={{color: 'blue'}}>点此下载</a>
                        </p>
                        <p> （2）理事会会议纪要（加盖机构公章）。</p>
                        <p>3．市社科联审查同意后，持市社科联的批复向市民政局登记处提交变更申请。</p>
                        <p>4．市民政局审查批准后，办理变更手续（民办非企业单位法人证书变更及组织结构代码证变更）。</p>
                        <p>5．将市民政局的有关批复材料报市社科联备案（15个工作日内）。</p>

                    </div>
                    <div className="panel-header">（二）变更法定代表人</div>
                    <div className="panel-body">
                        <p>1．民办社科研究机构酝酿变更法定代表人初步人选。</p>
                        <p>2．民办社科研究机构向市社科联提交拟任法定代表人推荐表。</p>
                        <p>3．市社科联对民办社科研究机构拟变更法定代表人初步人选进行审查把关。</p>
                        <p>4．民办社科研究机构拟变更法定代表人初步人选经市社科联审查同意后，民办社科机构组织召开理事会，表决通过法定代表人变更事宜。</p>
                        <p>5．向市社科联提交如下材料：</p>
                        <p> （1）变更申请。《关于天津市××××变更法定代表人（负责人）的请示》
                            <a href={`${baseUrl}关于天津市××××变更法定代表人的请示.docx`} style={{color: 'blue'}}>
                                点此下载
                            </a>
                        </p>
                        <p> （2）推荐表。民办社科研究机构拟任法人推荐表。
                            <a href={`${baseUrl}天津市××××拟任法定代表人推荐表.docx`}
                               style={{color: 'blue'}}>点此下载
                            </a>
                        </p>
                        <p> （2）理事会会议纪要（加盖机构公章）。</p>
                        <p>6．民办社科研究机构做法定代表人离任审计并报社科联审阅。</p>
                        <p>7．经审查同意后，民办社科研究机构持市社科联的批复向市民政局登记处提交申请。</p>
                        <p>8．市民政局登记处审查批准后，办理变更手续（民办非企业单位法人证书变更）。</p>
                        <p>9．将市民政局的有关批复材料报市社科联备案（15个工作日内）。</p>
                    </div>
                    <div className="panel-header">（三）届中变更理事</div>
                    <div className="panel-body">
                        <p>1．民办社科研究机构酝酿变更理事初步人选。</p>
                        <p>2．民办社科研究机构向市社科联提交拟变更理事推荐表。</p>
                        <p>3．市社科联对民办社科研究机构拟变更理事初步人选进行审查把关。</p>
                        <p>4．民办社科研究机构拟变更理事初步人选经市社科联审查同意后，民办社科研究机构组织召开理事会，表决通过理事变更事宜。</p>
                        <p>5．向市社科联提交如下材料：</p>
                        <p> （1）变更申请。《关于天津市××××变更理事的请示》<a
                            href={`${baseUrl}关于天津市××××变更理事的请示.docx`}
                            style={{color: 'blue'}}>点此下载</a>
                        </p>
                        <p> （2）推荐表。民办社科研究机构拟变更理事推荐表<a
                            href={`${baseUrl}天津市××××拟任理事（监事）推荐表.docx`} style={{color: 'blue'}}>点此下载</a>
                        </p>
                        <p> （3）理事会会议纪要（加盖机构公章）。</p>
                        <p>6．市社科联审查同意后，持市社科联的批复向市民政局办理变更备案手续。</p>
                    </div>

                    <div className="panel-header">（四）届中章程变更核准</div>
                    <div className="panel-body">
                        <p>1．民办社科研究机构变更章程，依照章程规定召开理事会讨论通过。</p>
                        <p>2.向市社科联提交如下材料：</p>
                        <p> （1） 变更申请。《关于天津市××××变更章程的请示》<a
                            href={`${baseUrl}关于天津市××××变更章程的请示.docx`}
                            style={{color: 'blue'}}>点此下载</a>
                        </p>
                        <p> （2）理事会会议纪要（加盖机构公章及参会人员签名）。</p>
                        <p> （3）新通过的章程。</p>
                        <p>3．经审查同意后，民办社科研究机构持市社科联审批的民办社科机构章程核准表向市民政局办理变更备案手续。</p>
                    </div>

                    <div className="panel-header">（五）变更住所</div>
                    <div className="panel-body">
                        <p>1．民办社科机构提交《关于天津市××××变更住所的说明》<a
                            href={`${baseUrl}关于天津市××××变更住所的说明.docx`}
                            style={{color: 'blue'}}>点此下载</a>
                        </p>
                    </div>
                    <div className="panel-header">（六）变更监事（长）</div>
                    <div className="panel-body">
                        <p>1．民办社科研究机构酝酿变更监事（长）初步人选。</p>
                        <p>2．民办社科研究机构向市社科联提交拟变更监事（长）基本情况表。
                            <a
                                href={`${baseUrl}天津市××××监事（长）拟变更人选基本情况表.docx`}
                                style={{color: 'blue'}}>点此下载
                            </a>
                        </p>
                        <p>3．市社科联对民办社科研究机构拟变更监事（长）初步人选进行审查把关。</p>
                        <p>4．民办社科研究机构拟变更监事（长）初步人选经市社科联审查同意后，民办社科研究机构组织召开理事会，表决通过监事（长）变更事宜。</p>
                        <p>5．向市社科联提交如下材料：</p>
                        <p> （1）《天津市××××监事会（监事）基本情况表》（盖机构章）<a
                            href={`${baseUrl}天津市××××监事会（监事）基本情况表.docx`}
                            style={{color: 'blue'}}>点此下载</a>
                        </p>
                        <p> （2）理事会会议纪要（加盖机构公章）。</p>
                        <p>6．市社科联同意后，到市民政局办理变更备案手续。</p>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ChangeRelationship;
